import React from 'react';
import useReveal from '../hooks/useReveal';
import './Platform.css';

const STEPS = [
  { n: '01', title: 'Enter the simulation', body: 'Learners step into a realistic 3D mushroom farm rendered with Unity, WebGL and Three.js — no equipment required.' },
  { n: '02', title: 'Practice every stage', body: 'Substrate prep, sterilization, spawn inoculation, incubation, fruiting, harvesting, and pest & disease management — in guided modules.' },
  { n: '03', title: 'Get real-time feedback', body: 'Change a variable — humidity, pH, timing — and watch predicted yield respond, just like a real crop would.' },
  { n: '04', title: 'Track & certify', body: 'Institutions monitor progress on a dashboard; learners graduate with performance-backed certification support.' },
];

const MODULES = [
  'Mushroom Basics', 'Substrate Preparation', 'Sterilization', 'Spawn Inoculation',
  'Incubation', 'Fruiting', 'Harvesting', 'Maintenance',
  'Pest & Disease Management', 'Marketing', 'Final Assessment',
];

export default function Platform() {
  const headRef = useReveal();
  const stepsRef = useReveal();
  const modRef = useReveal();

  return (
    <section className="section platform" id="platform">
      <div className="container">
        <div className="reveal" ref={headRef}>
          <p className="eyebrow">How it works</p>
          <h2 className="section-heading">
            A digital twin of the mushroom farm — practiced module by module, before it's real.
          </h2>
          <p className="section-sub">
            Built on digital-twin technology with a roadmap toward smart-glove motion control,
            so learners eventually drag, pinch and turn their way through a harvest with their
            own hands.
          </p>
        </div>

        <div className="platform__steps reveal-stagger" ref={stepsRef}>
          {STEPS.map((s) => (
            <div className="platform__step" key={s.n}>
              <span className="platform__step-n">{s.n}</span>
              <h3>{s.title}</h3>
              <p>{s.body}</p>
            </div>
          ))}
        </div>

        <div className="platform__modules reveal" ref={modRef}>
          <div className="platform__modules-label">
            <h3>Course modules</h3>
            <p>Mushroom Cultivation Simulation — current flagship course</p>
          </div>
          <div className="platform__modules-list">
            {MODULES.map((m) => (
              <span key={m} className="platform__chip">{m}</span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
